import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { useState } from 'react';
import { addOutline } from 'ionicons/icons';
import AttachemnetTable from './AttachemnetTable';
import ModalPopup from '@ui/components/VnModal';
import AddAttachmentsForm from './AddAttachmentsForm';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
import { VisserModule } from '@application/common/enums/visser-module';
import { updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
import { useAppDispatch } from '@application/store/useStore';
import { resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
const AttachmentsTab = ({ formData, errors, onFieldChange, onToggelButtonChange, onCalendarChange, disableWorkOrder, isAttachmentTabBold }) => {
    // const warningMessageRef = useRef<{ resetTimer: () => void } | null>(null);
    const dispatch = useAppDispatch();
    const [updateGrid, setUpdateGrid] = useState(false);
    const [isOpen, SetIsOpen] = useState(false);
    const [isPersistantInfoCustomToasterOpen, setIsPersistantInfoCustomToasterOpen] = useState(false);
    function oncloseClicked() {
        SetIsOpen(false);
    }
    const handleButtonClick = async () => {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            SetIsOpen(true);
        }
    };
    //-------------------Module Lock Functionality---------------------------
    const checkModulelock = async () => {
        // if (warningMessageRef.current) {
        //     warningMessageRef.current.resetTimer();
        // }
        if (formData.id) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Werkorder,
                recordId: formData.id
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
                if (res.isModuleAlreadyLocked) {
                    // setIsPersistantInfoCustomToasterOpen(true);
                    dispatch(setModuleLock());
                    return true;
                }
                // setIsPersistantInfoCustomToasterOpen(false);
                dispatch(unsetModuleLock());
                return false;
            }
            catch (error) {
                // setIsPersistantInfoCustomToasterOpen(false);
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'Vn-attachments-button', children: _jsx("div", { children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: addOutline, onClick: handleButtonClick, isDisabled: handleRolePermission(Permission.WBIJLAGEN, PermissionType.Create) && !disableWorkOrder ? false : true, children: "Toevoegen Bijlagen" }) }) }), _jsx("div", { className: 'mt-3', children: _jsx(AttachemnetTable, { formData: formData, updateGridCheck: updateGrid, isAttachmentTabBold: isAttachmentTabBold }) }), _jsx(ModalPopup, { title: 'Upload bestanden', content: _jsx(AddAttachmentsForm, { onClose: oncloseClicked, formData: formData, isAttachmentTabBold: isAttachmentTabBold }), onOpen: isOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' })] }));
};
export default AttachmentsTab;
